import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const RoundNameFlex = styled(Flex)`
  background: ${COLORS.BLUE_T_95};
  border-radius: 10px;
  padding: 15px;
  height: 66px;
  gap: 5px;
  margin-bottom: 25px;
`
export const RoundDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_XS};
  line-height: 15px;
  color: ${COLORS.GREY_T_50_2};
`
export const Roundname = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  color: ${COLORS.GREY_T_20};
  text-transform: capitalize;
`
export const InterviewerDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_30};
  margin: 8px 0 0 0;
`
export const StartSpan = styled.span`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_60};
`
export const ListInterviwer = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.GREY_T_30};
  margin: 15px 0;
`
export const FooterFlex = styled(Flex)`
  gap: 10px;
`
export const CommonDiv = styled.div`
  margin: 8px 0 25px 0;
  width: 100%;
`
export const StrenthDiv = styled.div`
  width: 33vh;
`
export const WeeknessDiv = styled.div`
  width: 33vh;
`
export const CommonFlex = styled(Flex)`
  gap: 15px;
  width: 68vh;
`
export const DetailsDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_20};
  margin: 5px 0;
`

export const Divider = styled(Flex)`
  border-right: 1px solid #e6e7ea;
  margin: 0px 25px 0px 15px;
  height: 56px;
`

export const BoxFlex = styled(Flex)`
  gap: 10px;
  margin: 0px 0 20px;
`

export const BoxFlexWrap = styled(Flex)`
  margin: 10px 0px 0px 0px;
`

export const RemarksDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_30};
  margin: ${props => (props?.isMargin ? '0px 0 5px 0' : '15px 0 10px 0')};
`
export const RemarksInfo = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_40};
  text-transform: capitalize;
`
export const SkilsBox = styled.div`
  width: ${props => !props?.width && '90px'};
  height: 40px;
  background: ${props => (!props?.isSelected ? '#f9fafe' : `${COLORS.WHITE}`)};
  border: ${props =>
    !props?.isSelected ? `1px solid ${COLORS.GREY_T_90}` : '1px solid #adb6ef'};
  border-radius: 10px;
  padding: 8px 12px;
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  text-align: center;
  color: ${COLORS.GREY_T_60};
  cursor: pointer;
  background: #f9fafe;
  color: ${props => props?.isSelected && '#3249d7'};
`

export const Wrapper = styled(Flex)`
  padding-bottom: 25px;
`

export const FlexWrapper = styled(Flex)`
  padding-top: 10px;
`

export const Padding = styled(Flex)`
  padding: 1px;
`

export const NameWrapper = styled(Flex)`
  font-style: normal;
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 20px;
  color: #4d566e;
  margin: 3px 10px;
`

export const ScoreFlex = styled(Flex)`
  gap: 10px;
  align-items: flex-start;
`

export const IconWrapper = styled(Flex)`
  margin-top: 20px;
  cursor: pointer;
  pointer-events: ${props => (props?.disable ? 'none' : 'auto')};
`
